import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Thumbs } from 'swiper/modules';

import slide1 from '../assets/img/slider/mobil-assistance-slider-1.jpg';
import slide2 from '../assets/img/slider/mobil-assistance-slider-2.jpg';
import slide3 from '../assets/img/slider/mobil-assistance-slider-3.jpg';
import slide4 from '../assets/img/slider/mobil-assistance-slider-4.jpg';
import slide5 from '../assets/img/slider/mobil-assistance-slider-5.jpg';

import icon from '../assets/img/MobilAssistance_icon.png';
import svg_yolyardim from '../assets/img/svg/yolyardim_svg.svg';
import svg_ikamearac from '../assets/img/svg/ikamearac_svg.svg';
import svg_callcenter from '../assets/img/svg/cagrimerkezi_svg.svg';
import svg_kisiyeozel from '../assets/img/svg/kisiyeozel_svg.svg';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const slides = [
  { id: 1, image: slide1 },
  { id: 2, image: slide2 },
  { id: 3, image: slide3 },
  { id: 4, image: slide4 },
  { id: 5, image: slide5 },
];

const SimpleSlider = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <section className="o-section c-slider-section overflow-hidden">
      <Swiper
        modules={[Navigation, Autoplay, Thumbs]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        autoplay={{
          delay: 6500,
          disableOnInteraction: false,
        }}
        loop
        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="bg bg2 c-slider-slide position-relative">
              <div className="row">
                <div className="position-relative w-100 c-slider-image-wrap">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-100"
                    style={{
                      objectFit: 'cover',
                      display: 'block',
                    }}
                    loading={slide.id === 1 ? 'eager' : 'lazy'}
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Alt kısımdaki ikonlu bullets alanı (eski slider2 yapısına benzer) */}
      <div className="c-full-slider__bullets">
        <div className="o-container">
          <div className="c-full-slider__bullets__wrapper">
            <Swiper
              onSwiper={setThumbsSwiper}
              loop
              watchSlidesProgress
              className="mySwiper"
              breakpoints={{
                0: { slidesPerView: 3, spaceBetween: 16 },
                576: { slidesPerView: 4, spaceBetween: 24 },
                992: { slidesPerView: 5, spaceBetween: 32 },
              }}
            >
              <SwiperSlide>
                <div className="c-full-slider__bullet--container">
                  <div className="c-full-slider__bullet">
                    <img src={icon} alt="Yol Yardım" width={42} />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="c-full-slider__bullet--container">
                  <div className="c-full-slider__bullet">
                    <img src={svg_yolyardim} alt="Yol Yardım" width={42} />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="c-full-slider__bullet--container">
                  <div className="c-full-slider__bullet">
                    <img src={svg_ikamearac} alt="İkame Araç" width={42} />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="c-full-slider__bullet--container">
                  <div className="c-full-slider__bullet">
                    <img src={svg_callcenter} alt="Çağrı Merkezi" width={42} />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="c-full-slider__bullet--container">
                  <div className="c-full-slider__bullet">
                    <img src={svg_kisiyeozel} alt="Kişiye Özel Hizmetler" width={42} />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimpleSlider;

